import { useBorrowerEntityName } from '../../../../../../../queries/BorrowerFields/EntityFields';
import { TextBox } from '@apply/components';
import { BorrowerEntityFieldLength } from '@apply/constants';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface BorrowerEntityProps {
    readOnly?: boolean;
    isReview?: boolean;
}

export const BorrowerEntity: React.FC<BorrowerEntityProps> = ({ readOnly = false, isReview = false }) => {
    const label = 'Borrower Entity';
    const [name, set_name] = useBorrowerEntityName();
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={name}
                />
            ) : (
                <TextBox
                    value={name}
                    onChange={(value) => set_name(value)}
                    label={label}
                    required={true}
                    readOnly={readOnly}
                    maxLength={BorrowerEntityFieldLength.name}
                />
            )}
        </>
    );
};
